module.exports = __webpack_public_path__ + "img/error-payment-connection.073ad97.svg";